import { render, staticRenderFns } from "./framework_categories.vue?vue&type=template&id=7fcf4a81&"
import script from "./framework_categories.vue?vue&type=script&lang=js&"
export * from "./framework_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports